import script from "./firm-inbox-company-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./firm-inbox-company-panel.vue?vue&type=script&setup=true&lang=js"

import "./firm-inbox-company-panel.vue?vue&type=style&index=0&id=b9a7f787&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9a7f787"]])

export default __exports__